





































/* eslint-disable */
import getUrlParam from '@/common/utils/getUrlParam';
import CONFIG from '@/common/config';
import { Component, Vue, Mixins } from 'vue-property-decorator';
import PageInitialMixin from '@/mixins/PageInitialMixin';
import { IntroItem } from '@/common/interface';
import { Getter, Action } from 'vuex-class';
import { replaceString } from '@/common/utils/dealWithString';
import fetch from '@/common/api/fetch';
const loadingImage = require('@/assets/img/loadingImage.gif');

interface section {
  textColor?: string;
}

@Component({
  components: {}
})
export default class ActivityInfo extends Vue {
  @Getter('contactQrcode') contactQrcode!: string;
  @Getter('title') title!: string;
  @Getter('instName') instName!: string;
  @Getter('deadline') deadline!: string;
  @Getter('activityRule') activityRule!: string;
  @Getter('instAddress') instAddress!: string;
  @Getter('instPhone') instPhone!: string;
  @Getter('activityIntros') getterActivityIntros!: Array<IntroItem>;
  @Getter('section') section!: section;

  @Getter('institutionIntros') institutionIntros!: Array<object>;
  @Action('changeShowFooter') changeShowFooter!: Function;

  isCopy: boolean = false;
  isFromDistribute: boolean = true;
  message: object = {};
  hidden: boolean = false;
  loadingImage: string = loadingImage;

  get activityIntros(): Array<IntroItem> {
    const tempArray: Array<IntroItem> = [];
    for (let i: number = 0, length: number = this.getterActivityIntros.length; i < length; i++) {
      const item: IntroItem = Object.assign({}, this.getterActivityIntros[i]);
      item.value = item.value && replaceString(item.value);
      tempArray.push(item);
    }
    return tempArray;
  }
  created() {
    const isCopy = getUrlParam('state') == 'copy';
    this.isCopy = isCopy;
    this.dealData();
  }
  mounted() {}
  dealData(): void {
    this.message = {
      contactQrcode: this.contactQrcode,
      title: this.title,
      instName: this.instName,
      deadline: this.deadline,
      activityRule: this.activityRule,
      instAddress: this.instAddress,
      instPhone: this.instPhone,
      institutionIntros: this.institutionIntros
    };
    console.log(this.message);
  }
  goNext(): void {
    let url = `/pages/ask-info/index?openid=${this.$store.state.openId}`;
    console.log('redirect', url);
    window.wx.miniProgram.redirectTo({
      url
    });
  }
  handleVideo(item: any) {
    fetch.parseUrl(item.value).then((res: any) => {
      const query = {
        url: res || item.value
      };
      this.$router.push({
        name: 'video',
        query: query
      });
    });
  }
}
